import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import UIImage from 'UIComponents/image/UIImage'; // @ts-expect-error svgs are untyped modules

import diamondTierBorderedIconUrl from 'bender-url!marketplace-ui-solutions-core/img/diamond-tier-icon-bordered.svg'; // @ts-expect-error svgs are untyped modules

import diamondTierIconUrl from 'bender-url!marketplace-ui-solutions-core/img/diamond-tier-icon.svg'; // @ts-expect-error svgs are untyped modules

import eliteTierBorderedIconUrl from 'bender-url!marketplace-ui-solutions-core/img/elite-tier-icon-bordered.svg'; // @ts-expect-error svgs are untyped modules

import eliteTierIconUrl from 'bender-url!marketplace-ui-solutions-core/img/elite-tier-icon.svg'; // @ts-expect-error svgs are untyped modules

import goldTierBorderedIconUrl from 'bender-url!marketplace-ui-solutions-core/img/gold-tier-icon-bordered.svg'; // @ts-expect-error svgs are untyped modules

import goldTierIconUrl from 'bender-url!marketplace-ui-solutions-core/img/gold-tier-icon.svg'; // @ts-expect-error svgs are untyped modules

import platinumTierBorderedIconUrl from 'bender-url!marketplace-ui-solutions-core/img/platinum-tier-icon-bordered.svg'; // @ts-expect-error svgs are untyped modules

import platinumTierIconUrl from 'bender-url!marketplace-ui-solutions-core/img/platinum-tier-icon.svg'; // @ts-expect-error svgs are untyped modules

import solutionsPartnerBorderedIconUrl from 'bender-url!marketplace-ui-solutions-core/img/solutions-partner-icon-bordered.svg'; // @ts-expect-error svgs are untyped modules

import solutionsPartnerIconUrl from 'bender-url!marketplace-ui-solutions-core/img/solutions-partner-icon.svg'; // @ts-expect-error svgs are untyped modules

import solutionsProviderBorderedIconUrl from 'bender-url!marketplace-ui-solutions-core/img/solutions-provider-icon-bordered.svg'; // @ts-expect-error svgs are untyped modules

import solutionsProviderIconUrl from 'bender-url!marketplace-ui-solutions-core/img/solutions-provider-icon.svg';
import * as PartnerTiers from '../constants/PartnerTier';
import * as PartnerTypes from '../constants/PartnerType';
const PARTNER_TIER_ICONS = {
  [PartnerTiers.ELITE]: [eliteTierIconUrl, eliteTierBorderedIconUrl],
  [PartnerTiers.DIAMOND]: [diamondTierIconUrl, diamondTierBorderedIconUrl],
  [PartnerTiers.PLATINUM]: [platinumTierIconUrl, platinumTierBorderedIconUrl],
  [PartnerTiers.GOLD]: [goldTierIconUrl, goldTierBorderedIconUrl],
  [PartnerTiers.NONE]: [solutionsPartnerIconUrl, solutionsPartnerBorderedIconUrl]
};
const SOLUTIONS_PROVIDER_ICONS = [solutionsProviderIconUrl, solutionsProviderBorderedIconUrl];
var ICON_SIZES;

(function (ICON_SIZES) {
  ICON_SIZES[ICON_SIZES["small"] = 16] = "small";
  ICON_SIZES[ICON_SIZES["medium"] = 32] = "medium";
  ICON_SIZES[ICON_SIZES["large"] = 48] = "large";
})(ICON_SIZES || (ICON_SIZES = {}));

const PartnerTypeIcon = (_ref) => {
  let {
    bordered,
    partnerType,
    size,
    tier
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["bordered", "partnerType", "size", "tier"]);

  const computedIconSize = useMemo(() => {
    if (size && Object.prototype.hasOwnProperty.call(ICON_SIZES, size)) {
      return ICON_SIZES[size];
    }

    return size;
  }, [size]);
  const computedIconUrl = useMemo(() => {
    let iconUrl;
    let borderedIconUrl;

    switch (partnerType) {
      case PartnerTypes.PARTNER:
      case PartnerTypes.RESELLER:
        {
          [iconUrl, borderedIconUrl] = PARTNER_TIER_ICONS[tier || PartnerTiers.NONE];
          break;
        }

      case PartnerTypes.PROVIDER:
        {
          [iconUrl, borderedIconUrl] = SOLUTIONS_PROVIDER_ICONS;
          break;
        }

      default:
        return null;
    }

    return bordered ? borderedIconUrl : iconUrl;
  }, [bordered, partnerType, tier]);

  if (!computedIconUrl) {
    return null;
  }

  return /*#__PURE__*/_jsx(UIImage, Object.assign({}, rest, {
    responsive: false,
    objectFit: "contain",
    src: computedIconUrl,
    width: computedIconSize
  }));
};

export default PartnerTypeIcon;